"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productImportErrorCodes = void 0;
exports.productImportErrorCodes = {
    MISSING_HEADERS: 'MISSING_HEADERS',
    FIELD_REQUIRED: 'FIELD_REQUIRED',
    FIELD_TOO_LONG: 'FIELD_TOO_LONG',
    INVALID_BOOLEAN_VALUE: 'INVALID_BOOLEAN_VALUE',
    INVALID_NUMBER_FORMAT: 'INVALID_NUMBER_FORMAT',
    FORBIDDEN_VALUE: 'FORBIDDEN_VALUE',
    INVALID_DATES: 'INVALID_DATES',
    INVALID_VALUE: 'INVALID_VALUE',
    CATALOGUE_SERVICES_COLUMNS_INCONSISTENT: 'CATALOGUE_SERVICES_COLUMNS_INCONSISTENT',
    CATALOGUE_INVALID_PRODUCT_UID_FORMAT: 'CATALOGUE_INVALID_PRODUCT_UID_FORMAT',
    CATALOGUE_INVALID_PRODUCT_UID_PREFIX: 'CATALOGUE_INVALID_PRODUCT_UID_PREFIX',
    CATALOGUE_INVALID_RPD_UNIT: 'CATALOGUE_INVALID_RPD_UNIT',
    CATALOGUE_INVALID_STOCK_STRATEGY: 'CATALOGUE_INVALID_STOCK_STRATEGY',
    CATALOGUE_INVALID_PROFILE: 'CATALOGUE_INVALID_PROFILE',
    CATALOGUE_RPD_FIELDS_INCONSISTENT: 'CATALOGUE_RPD_FIELDS_INCONSISTENT',
    CATALOGUE_NEGATIVE_VALUE: 'CATALOGUE_NEGATIVE_VALUE',
    CATALOGUE_INVALID_SERVICE_FORMAT: 'CATALOGUE_INVALID_SERVICE_FORMAT',
    CATALOGUE_SERVICE_GROUPS_NOT_ALLOWED: 'CATALOGUE_SERVICE_GROUPS_NOT_ALLOWED',
    CATALOGUE_DUPLICATE_VARIANT: 'CATALOGUE_DUPLICATE_VARIANT',
    CATALOGUE_PRODUCT_NOT_EXISTS_OR_REMOVED: 'CATALOGUE_PRODUCT_NOT_EXISTS_OR_REMOVED',
    CATALOGUE_PRODUCT_SKU_CHANGED: 'CATALOGUE_PRODUCT_SKU_CHANGED',
    PRODUCT_INVALID_NUMBER_LIST_FORMAT: 'PRODUCT_INVALID_NUMBER_LIST_FORMAT',
    PRODUCT_DUPLICATE_PRODUCT: 'PRODUCT_DUPLICATE_PRODUCT',
    PRODUCT_NOT_FOUND_IN_CATALOG: 'PRODUCT_NOT_FOUND_IN_CATALOG',
    PRODUCT_PHYTO_PRODUCT_ASSOCIATION_NOT_ALLOWED: 'PRODUCT_PHYTO_PRODUCT_ASSOCIATION_NOT_ALLOWED',
    ZONE_CHARGE_DUPLICATE_LINE: 'ZONE_CHARGE_DUPLICATE_LINE',
    ZONE_CHARGE_PRODUCT_NOT_IN_CATALOG: 'ZONE_CHARGE_PRODUCT_NOT_IN_CATALOG',
    ZONE_CHARGE_INVALID_NUMBER_FORMAT: 'ZONE_CHARGE_INVALID_NUMBER_FORMAT',
};
